var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFormValues } from 'redux-form';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { propMatch } from '@/helpers/custom-prop-types';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { showAlert } from '../../../actions/NotificationActions';
import { API_GET_ONE_SOLUTION, apiCreateOneOrder as apiCreateOneOrderAction, apiGetOneSolution, } from '../../../actions/OneSolutionActions';
import { DISABLE_INQUIRY_DUPLICATE, DISABLE_INQUIRY_MAXIMUM, ORDER_ERROR_MESSAGES, } from '../../../define/consts/solution_order';
import { BAD_INQUIRY_DUPLICATE, BAD_INQUIRY_MAXIMUM, } from '../../../define/response';
import { wrapDispatch } from '../../../helpers/action';
import { isLoadingApis } from '../../../helpers/fetch';
import { getErrorFromErrorObject } from '../../../helpers/validate';
import Layout from '../../Layout';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import OrderConfirmContent from './OrderConfirmContent';
const OrderConfirm = (props) => {
    const { match } = props;
    const { params: { id }, url, } = match || {};
    const history = useNavigate();
    const { formValues, isForbidden, isLoading, item } = useSelector((state) => {
        const { fetch, oneSolution } = state;
        const one = oneSolution[id] || {};
        return {
            formValues: getFormValues('FormOrderInquiry')(state) || {},
            isForbidden: !!one.forbidden,
            isLoading: isLoadingApis(fetch, API_GET_ONE_SOLUTION),
            item: one.one || null,
        };
    });
    const dispatch = useDispatch();
    const isProffit = useMemo(() => url.indexOf('proffit_order') > 0, [url]);
    useEffect(() => {
        if (!formValues || !Object.keys(formValues).length) {
            history.push(`/solutions/${id}/order`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (!item) {
            dispatch(apiGetOneSolution(id, {
                resolve: ({ payload }) => {
                    const messages = ORDER_ERROR_MESSAGES[payload.inquiryStatus] || '';
                    if (!isProffit && messages) {
                        dispatch(showAlert(messages));
                        history.push(`/solutions/${id}`);
                    }
                },
            }));
        }
    }, [history, dispatch, id, item, isProffit]);
    const submitOrder = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield wrapDispatch(dispatch, apiCreateOneOrderAction(id, formValues, isProffit));
            history.push(`/solutions/${id}/${isProffit ? 'proffit_order' : 'order'}/complete`);
        }
        catch (e) {
            const { code } = getErrorFromErrorObject(e);
            switch (code) {
                case BAD_INQUIRY_DUPLICATE:
                    dispatch(showAlert(ORDER_ERROR_MESSAGES[DISABLE_INQUIRY_DUPLICATE]));
                    break;
                case BAD_INQUIRY_MAXIMUM:
                    dispatch(showAlert(ORDER_ERROR_MESSAGES[DISABLE_INQUIRY_MAXIMUM]));
                    break;
                default:
            }
        }
    }), [history, dispatch, id, isProffit, formValues]);
    const onBack = useCallback(() => {
        history.push(`/solutions/${id}/order`);
    }, [history, id]);
    if (isForbidden) {
        return _jsx(CustomRedirect, { to: `/solutions/${id}/` });
    }
    return (_jsx(Layout, Object.assign({ mainClassName: 'l-main archives' }, { children: _jsx(OrderConfirmContent, { formValues: formValues, isLoading: !item || isLoading, isProffit: isProffit, item: item, onBack: onBack, submitOrder: submitOrder }) })));
};
OrderConfirm.propTypes = {
    match: propMatch(),
};
export default AuthenticationHoc({
    isCanUseProffitMart: true,
    isClient: true,
})(OrderConfirm);
